/** @format */

import { buildComponentInteractionParams } from 'src/analytics/buildGa4EventPayload';
import { trackGa4 } from 'src/analytics/trackGa4';
import type { Ga4ComponentInteractionParams } from 'src/analytics/ga4Parameters';
import type { TrackGa4Options } from 'src/analytics/trackGa4';

export const GA4_COMPONENT_NAME = Object.freeze({
  HERO_CTA: 'hero_cta',
  BACK_TO_HOME: 'back_to_home',
  BACK_BUTTON: 'back_button',
  CONTENT_PRINT: 'content_print',
  CONTENT_SHARE: 'content_share',
  CTA_REGISTER: 'cta_register',
  DOWNLOAD_TILE: 'download_tile'
});

export const GA4_COMPONENT_TYPE = Object.freeze({
  BUTTON: 'button',
  TILE: 'tile'
});

export const GA4_COMPONENT_POSITION = Object.freeze({
  HERO: 'hero',
  NEWS_LIST: 'news_list',
  EVENTS_LIST: 'events_list',
  NEWS_DETAIL: 'news_detail',
  KNOWLEDGE_BASE_DETAIL: 'knowledge_base_detail',
  CONTENT_PAGE: 'content_page',
  EXTRANET_CONTENT_DETAIL: 'extranet_content_detail',
  EXTRANET_CONTENT_DRAWER: 'extranet_content_drawer'
});

export interface ResolveBackButtonGa4PositionOptions {
  kb?: string;
  isNews?: boolean;
  componentPosition?: string;
}

export function resolveBackButtonGa4Position({
  kb,
  isNews,
  componentPosition
}: ResolveBackButtonGa4PositionOptions = {}): string {
  if (componentPosition) {
    return componentPosition;
  }
  if (kb) {
    return GA4_COMPONENT_POSITION.KNOWLEDGE_BASE_DETAIL;
  }
  if (isNews) {
    return GA4_COMPONENT_POSITION.NEWS_DETAIL;
  }
  return GA4_COMPONENT_POSITION.CONTENT_PAGE;
}

export function trackComponentInteraction(
  params: Ga4ComponentInteractionParams = {},
  options: TrackGa4Options = {}
): void {
  trackGa4('component_interaction', buildComponentInteractionParams(params), options);
}
